export class UserType {
    address:string="";
date:Date=  new Date();
dob:Date =  new Date()
email:string="";
formations:string[] = []
gender:string="";
id:string="";
img:string="";
mobile:number=0;
name:string="";
profession:string="";
role:string="";
}